import Immutable from 'seamless-immutable'
import _ from 'lodash'

import * as authenticationActions from 'external/reduxBits/authentication/actions'
import * as actions from './actions'

const initialState = Immutable.from({
  isCreating: false,
  isFetching: true,
  hasFetched: false,
  error: false,
  errorType: null,
  items: [],
})

export const resetNewCountById = (state, id) => {
  return state.merge({
    items: state.items.map((item) => (item.id === id ? { ...item, newCount: 0 } : item)),
  })
}

export const resetAllNewCount = (state) => {
  return state.merge({
    items: state.items.map((item) => ({ ...item, newCount: 0 })),
  })
}

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case authenticationActions.LOGOUT:
      return initialState

    case actions.REQUEST_CREATE_AD_WATCH:
      return state.merge({
        isCreating: true,
      })
    case actions.RECEIVE_CREATE_AD_WATCH:
      if (payload.error) {
        return state.merge({
          isCreating: false,
          error: true,
          errorType: payload.errorType,
        })
      }

      return state.merge({
        isCreating: false,
        items: state.items.concat(payload),
      })

    case actions.RESET_SAVE_AD_WATCH_ERROR:
      return state.merge({
        isCreating: false,
        error: false,
        errorType: null,
      })

    case actions.REQUEST_DELETE_AD_WATCH:
      return state.merge({
        isDeleting: true,
        error: false,
      })
    case actions.RECEIVE_DELETE_AD_WATCH:
      if (error) {
        return state.merge({
          isDeleting: false,
          error: true,
        })
      }

      return state.merge({
        isDeleting: false,
        items: _.reject(state.items, (o) => o.id === payload),
      })

    case actions.REQUEST_AD_WATCHES:
      return state.merge({
        isFetching: true,
        error: false,
      })
    case actions.RECEIVE_AD_WATCHES:
      if (error) {
        return state.set('error', true)
      }
      return state.merge({
        isFetching: false,
        hasFetched: true,
        error: false,
        items: payload.items,
        timestamp: payload.timestamp,
      })

    case actions.REQUEST_MARK_ADWATCHES_READ:
      return resetAllNewCount(state)

    case actions.RECEIVE_AD_WATCH_ADS:
      if (payload.adwatchId && payload.adwatchId !== 'all') {
        return resetNewCountById(state, payload.adwatchId)
      }
      return state

    default:
      return state
  }
}
